import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';

/**
 * Composant de route protégée
 * Vérifie l'authentification et les permissions avant d'afficher le contenu
 */
const ProtectedRoute = ({ children, moduleId, user }) => {
  const location = useLocation();
  const { canAccessModule } = usePermissions(user);

  // Si pas d'utilisateur, rediriger vers login
  // (normalement géré au niveau App, mais sécurité supplémentaire)
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Vérifier les permissions si un moduleId est spécifié
  if (moduleId && !canAccessModule(moduleId)) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export default ProtectedRoute;
